import React, { useState } from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box, Tab, Tabs } from '@mui/material';
import { useOutletContext } from 'react-router';
import { EmptyState, PageHeader, folderTabs } from 'dashboard/components/common';
import ConfigTab from './ConfigTab';
import TemplatesTab from './TemplatesTab';

/**
 * Brand mail control panel: sender identity + SendGrid keys live in
 * Configuration, custom subject/body overrides in Templates.
 */
export default function MailManager() {
  const [selectedBrand] = useOutletContext();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <Box mb='20px'>
        <PageHeader
          title='Mail manager'
          subtitle='Control how this brand sends email — sender identity, SendGrid integration, and templates.'
        />
      </Box>

      {!selectedBrand ? (
        <EmptyState>Select a brand to configure its mail.</EmptyState>
      ) : (
        <Box>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ ...folderTabs, mb: '16px' }}>
            <Tab label='Configuration' />
            <Tab label='Templates' />
          </Tabs>
          {tab === 0 && <ConfigTab brandId={selectedBrand} />}
          {tab === 1 && <TemplatesTab brandId={selectedBrand} />}
        </Box>
      )}
    </Box>
  );
}
